import './main.less';
import React from 'react';
import PropTypes from 'prop-types';
import { Form, FieldArray, reduxForm } from 'redux-form';

import LangSwitch from '../../../../shared/lang/switch';
import RenderFieldArray from './render-field-array';

const propTypes = {
	restrictedGeoTabLangs: PropTypes.array,
	handleSubmit: PropTypes.func,
	restrictedGeoFormData: PropTypes.object,
	restrictedGeoSubmit: PropTypes.func,
	restrictedGeoTranslateSubmit: PropTypes.func,
	restrictedGeoChangeLangs: PropTypes.func,
	intl: PropTypes.func
};

const Main = props => {
	const actionSubmit = !props.restrictedGeoFormData.isTranslateTab
		? props.restrictedGeoSubmit
		: props.restrictedGeoTranslateSubmit;

	return (
		<div className="offers-form-wrap">
			<div className="offers-form-wrap__langs">
				<LangSwitch langs={props.restrictedGeoTabLangs} onChangeLang={props.restrictedGeoChangeLangs}/>
			</div>

			<Form
				className="ui-form restricted-geo-form"
				onSubmit={props.handleSubmit(data => actionSubmit(data) )}>
				<FieldArray name="geo" component={RenderFieldArray} {...props} />
			</Form>

		</div>
	);
};

Main.propTypes = propTypes;

export default reduxForm({
	form: 'offerRestrictionGeoForm'
})(Main);


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/programs/components/forms/restricted-geo/main.js